import template from './ko-render-field-url.html';

class URLInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.hide_labels = ko.observable(params.hide_labels);
		this.$input = params.$input;
		this.readonly = ko.observable(params.readonly);
	}
}


export default {
	name: 'ko-render-field-url',
	viewModel: URLInputComponentVM,
	module_type: 'ko',
	template: template
}
